import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { classnames } from 'Utils/classnames';

export class Button extends Component {

  static propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.any,
    type: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    title: PropTypes.string,
  };

  render () {
    const { id, title, type, disabled, className, onClick, children, ...restProps } = this.props;

    const buttonClass = classnames({
      btn: true,
      [className]: className
    });

    return (
      <button
        id={ id }
        title={ title }
        type={ type || 'button' }
        disabled={ disabled || false }
        className={ buttonClass }
        onClick={ onClick || null }
        { ...restProps }
      >
        { children }
      </button>
    );
  }

}
